import * as patternomaly from 'patternomaly'
import { Chart } from 'chart.js/auto'

export const chartjs = { Chart }

export { patternomaly, Chart }
